/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Status_Processing_PdfInputs */

const en_conversion_status_processing_pdf = /** @type {(inputs: Conversion_Status_Processing_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing PDF`)
};

const es_conversion_status_processing_pdf = /** @type {(inputs: Conversion_Status_Processing_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando PDF`)
};

/**
* | output |
* | --- |
* | "Processing PDF" |
*
* @param {Conversion_Status_Processing_PdfInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_status_processing_pdf = /** @type {((inputs?: Conversion_Status_Processing_PdfInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Status_Processing_PdfInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_status_processing_pdf(inputs)
	return en_conversion_status_processing_pdf(inputs)
});